import { FC } from 'react';
import { cn } from "utils";
import Close from '../Icon/close.svg'
import { ElProps } from '@/type';


export interface ModalProps extends ElProps {
  visible: boolean;
  close: () => void;
  children?: React.ReactNode;
  modalContainerClassName?: string;
  closeAble?: boolean,
}

export const Modal: FC<ModalProps> = ({visible, close,children,modalContainerClassName, className,closeAble=true}) => {

  return (
    <div className={cn(
      'justify-center items-center gap-6  md:w-screen h-screen bg-Backgroun-Disabled/30 fixed top-0 z-[200] w-full px-4 md:px-0 left-0', {
        "flex": visible,
        "hidden": !visible
    }, className)}
    >
      <div className={cn('bg-Backgroun-Primary rounded-2xl flex flex-col w-112.5 h-fit overflow-hidden relative', modalContainerClassName)}>
        {children}
        {
          closeAble && (
          <div className="absolute right-4 top-4 inline-flex flex-row w-fit h-6 cursor-pointer" onClick={close}>
            <Close className="w-6 h-full" />
          </div>
          )
        }
      </div>
    </div>
  )
}